import { SidebarModal, Text } from '@domain-group/suit-theme'

import useActivities from '@hooks/useActivities'
import type { UseArtworkPayload } from '@hooks/useArtwork'

import ActivityItem from '@components/ActivityListItem'
import BlankState from '@components/EntityActivity/BlankState'

import ActivityImageUrl from '@assets/activity.svg'

interface ActivityProps {
  artworkPayload: UseArtworkPayload,
}

const ActivityList = (props: ActivityProps) => {
  const { artworkPayload: { artwork } } = props

  const activitiesPayload = useActivities({
    filters: {
      recipient_type: 'Artwork',
      recipient_id: artwork.id,
    },
    performHttpRequests: !!artwork.id,
    requestOptions: {
      include_activity_owner: true,
      include_activity_owner_image: true,
    },
  })

  const {
    filteredActivities,
    filteredActivitiesCount,
    hasFilteredActivities,
    loading,
  } = activitiesPayload

  return (
    <SidebarModal.ExpandableSection
      label="Artwork Activity"
      title={<Text marginTop="medium">View Activity</Text>}
      style={{ marginTop: '16px' }}
    >

      {!loading && !hasFilteredActivities && (
        <BlankState
          imageUrl={ActivityImageUrl}
          title="No Activity"
          subtitle="Activity will be logged here once work starts."
        />
      )}

      {!loading && hasFilteredActivities
      && (filteredActivities.map((activity, index) => (
        <ActivityItem
          activity={activity}
          boxProps={{ paddingY: 'large' }}
          isLastActivity={index === (filteredActivitiesCount - 1)}
          key={activity.id}
        />
      ))
      )}
    </SidebarModal.ExpandableSection>
  )
}

export default ActivityList
